const INSUFFICIENT_WALLET_BALANCE_PATTERN = /insufficient wallet balance/i;

export const DEFAULT_INSUFFICIENT_PETTY_CASH_MESSAGE =
  "Insufficient petty cash balance";

export const getTransactionMessage = (payload, fallback = "") => {
  const rawMessage = String(
    payload?.message || payload?.error || payload?.detail || fallback || "",
  ).trim();

  if (!rawMessage) return "";

  if (INSUFFICIENT_WALLET_BALANCE_PATTERN.test(rawMessage)) {
    return DEFAULT_INSUFFICIENT_PETTY_CASH_MESSAGE;
  }

  return rawMessage;
};

export const resolveTransactionFeedback = (
  payload,
  {
    successMessage = "Transaction completed successfully",
    approvalMessage = "Transaction sent for approval",
    errorMessage = "Failed to process transaction",
  } = {},
) => {
  const hasExplicitStatus = typeof payload?.status === "boolean";
  const success = hasExplicitStatus ? payload.status : payload != null;
  const approvalRequired = Boolean(payload?.approval_required);

  const message = getTransactionMessage(
    payload,
    success
      ? approvalRequired
        ? approvalMessage
        : successMessage
      : errorMessage,
  );

  return {
    success,
    approvalRequired,
    message,
    alertType: success ? (approvalRequired ? "info" : "success") : "error",
  };
};
